<template>
	<el-form :model="formData" ref="form" :rules="formRules">
    <el-col :span="12">
      <el-form-item :label="$t('kpi-config.start-date')" prop="startDate">
        <el-date-picker
            v-model="formData.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('vendor.contract.select-date')"
            style="width:100%">
          </el-date-picker>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item :label="$t('kpi-config.level')" prop="level">
          <el-select v-model="formData.level" 
          :placeholder="$t('profile.sex-ph')" style="width:100%"
          >
            <el-option :key="-10" :label="$t('kpi-config.all')" :value="-10"></el-option>
            <el-option
              v-for="item in level"
              :key="item.id"
              :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item :label="$t('kpi-config.team')" prop="team">
          <el-select v-model="formData.team" 
          :placeholder="$t('profile.sex-ph')" style="width:100%"
          >
            <el-option :key="-10" :label="$t('kpi-config.all')" :value="-10"></el-option>
            <el-option
              v-for="item in team"
              :key="item.id"
              :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item :label="$t('kpi-config.practice')" prop="practiceId">
          <el-select v-model="formData.practiceId" 
          :placeholder="$t('profile.sex-ph')" style="width:100%"
          >
            <el-option :key="-10" :label="$t('kpi-config.all')" :value="-10"></el-option>
            <el-option
              v-for="item in practice"
              :key="item.id"
              :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item :label="$t('kpi-config.kpi')" prop="item">
          <el-select v-model="formData.item" 
          :placeholder="$t('profile.sex-ph')" style="width:100%"
          >
            <el-option
              v-for="item in kpiItems"
              :key="item.id"
              :label="$i18n.locale === 'zh' ? item.c_name : item.e_name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item :label="$t('kpi-config.request-value')" prop="value">
        <el-input-number v-model="formData.value" :precision="2" :step="0.01" :min="0" :max="100" :label="$t('kpi-config.request-value')" style="width:100%"></el-input-number>
      </el-form-item>
    </el-col>
  </el-form>
</template>
<script>
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'KPI',
  props: ['data'],
  data: function() {
  	return {
      formData: {
        id: null,
        userId: null,
        startDate: null,
        practiceId: -10,
        level: -10,
        team: -10,
        item: null,
        value: null,
        weight: null
      },
      formRules: {
        'practiceId': [{required: true, message: this.$t('kpi-config.validate.practice'), trigger: ['blur', 'change']}],
        'team': [{required: true, message: this.$t('kpi-config.validate.team'), trigger: ['blur', 'change']}],
        'level': [{required: true, message: this.$t('kpi-config.validate.level'), trigger: ['blur', 'change']}],
        'item': [{required: true, message: this.$t('kpi-config.validate.item'), trigger: ['blur', 'change']}]
      }
  	}
  },
  computed: {
    isEdit: function() {
      return this.formData.id > 0
    }
  },
  methods: {
    createKPI: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //close model
          let loading = Loading.service({ fullscreen: true }),
              that = this
          this.formData.userId = localStorage.getItem('token')
          
          if (this.isEdit) {
            this.$http.put(this.API3_PREFIX + 'kpi_configuration', this.formData).then(function (response) {
              that.$nextTick(() => {
                loading.close()
              })
              that.$emit('value-save', that.formData)

              that.$message({
                message: that.$t('kpi-config.success'),
                type: 'success'
              })
            }).catch(function (error) {
              console.log(error)
              that.$nextTick(() => {
                loading.close()
              })
              
              that.$message({
                message: that.$t('kpi-config.failed'),
                type: 'error'
              })
              
            })
          } else {
            this.$http.post(this.API3_PREFIX + 'kpi_configuration', this.formData).then(function (response) {
              that.$nextTick(() => {
                loading.close()
              })
              that.$emit('value-save', that.formData)

              that.$message({
                message: that.$t('kpi-config.success'),
                type: 'success'
              })
            }).catch(function (error) {
              console.log(error)
              that.$nextTick(() => {
                loading.close()
              })
              that.$message({
                message: that.$t('kpi-config.failed'),
                  type: 'error'
              })
            })
          }
        } else {
          // do stuff if not valid.
          this.$message({
            message: this.$t('kpi-config.invalid'),
            type: 'error'
          })
          return false
        }
      })
    }
  },
  created: function() {

  }
}
</script>